import controller from './conference-details.controller.js';

let conferenceDetailsModule = angular.module('conference-details', [])

    .directive('conferenceDetails', () => {
        'ngInject';

        return {
            retrict: 'EA',
            controller: controller,
            controllerAs: '$ctrl',
            scope: {
                conferenceId: '@',
                conferencePackageId: '@',
                userStatus: '@',
                charLimit: '@',
                mode: '@',
                isRegistered: '=',
                onLoad: '@',
                review: '@',
                workshopOnly: '@',
                allowChanges: '='
            },
            bindToController: true,
            transclude: true,
            link: (scope, element, attrs, ctrlr, transclude) => {
                transclude(scope, (clone, scope) => {
                    element.append(clone);
                });
            }
        };
    })

    .name;

export default conferenceDetailsModule;



// WEBPACK FOOTER //
// ./src/app/angular/conference-details/conference-details.js